"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addressSchema = exports.profileSchema = exports.billingPhoneNumberValidator = exports.phoneNumberValidator = exports.stateValidator = exports.countryValidator = exports.cityValidator = exports.zipCodeValidator = exports.addressValidator = exports.dateOfBirthValidator = exports.lastNameValidator = exports.firstNameValidator = void 0;
var yup = __importStar(require("yup"));
var validation_1 = __importDefault(require("../config/validation"));
exports.firstNameValidator = yup
    .string()
    .required()
    .max(30)
    .min(2)
    .matches(/^[a-z ,.'-]+$/i);
exports.lastNameValidator = yup
    .string()
    .required()
    .max(30)
    .min(2)
    .matches(/^[a-z ,.'-]+$/i);
exports.dateOfBirthValidator = yup
    .date()
    .required()
    .min(validation_1.default.minDateOfBirth)
    .max(validation_1.default.maxDateOfBirth);
exports.addressValidator = yup
    .string()
    .required()
    .max(255)
    .matches(/.*\S.*/);
exports.zipCodeValidator = validation_1.default.zipCodeValidator;
exports.cityValidator = yup.string().required().max(255);
exports.countryValidator = yup.string().required().max(255);
exports.stateValidator = yup.string().required().max(255);
exports.phoneNumberValidator = yup.string().matches(validation_1.default.phoneValidationRegex);
exports.billingPhoneNumberValidator = yup
    .string()
    .required()
    .matches(validation_1.default.phoneValidationRegex);
exports.profileSchema = yup.object().shape({
    firstName: exports.firstNameValidator,
    lastName: exports.lastNameValidator,
    dateOfBirth: exports.dateOfBirthValidator,
    phone: exports.phoneNumberValidator
});
exports.addressSchema = yup.object().shape({
    address1: exports.addressValidator,
    city: exports.cityValidator,
    zipCode: validation_1.default.zipCodeValidator(),
    country: exports.countryValidator,
    state: exports.stateValidator
});
//# sourceMappingURL=profile-validations.js.map